export const Role = {
  User: 3,
};
